import { fetchApi } from '@/config/axiosSetting.ts';
import { SidebarQueryResponseType } from '@/modules/Dashboard/queries/sidebar/sidebarQuery.type.ts';

export const sidebarQueryFunction = (): Promise<SidebarQueryResponseType> =>
  fetchApi.get('sidebar/');
